import { TreatmentWithConfig } from '@splitsoftware/splitio/types/splitio';
import { ActiveSplitExperiment, FEATURE_FLAG_STATUS } from 'src/services/experiments/client/ongoingExperiments';
import { SPLIT_EXPERIMENTS } from 'src/services/experiments/client/ongoingExperiments';
import { ZILLOW_AUTH_PROVIDER } from 'src/services/auth/constants';

export const getAppropriateProvider = (
    experiments: Record<ActiveSplitExperiment, TreatmentWithConfig | null>
): ZILLOW_AUTH_PROVIDER => {
    const auth0Experiment = experiments[SPLIT_EXPERIMENTS.HOME_LOANS_DASHBOARD_AUTH_MIGRATION];
    const shortAuthExperiment = experiments[SPLIT_EXPERIMENTS.HOME_LOANS_DASHBOARD_SHORT_AUTH];
    const isAuth0Active = !!auth0Experiment && auth0Experiment.treatment === FEATURE_FLAG_STATUS.ON;
    if (isAuth0Active) {
        return ZILLOW_AUTH_PROVIDER.AUTH0;
    }
    const isShortAuthActive = !!shortAuthExperiment && shortAuthExperiment.treatment === FEATURE_FLAG_STATUS.ON;
    if (isShortAuthActive) {
        return ZILLOW_AUTH_PROVIDER.SHORT_ZILLOW_AUTH;
    }
    return ZILLOW_AUTH_PROVIDER.ZILLOW_AUTH;
};
